module.exports = __webpack_public_path__ + "static/media/5_polished_stainless_steel_seamless.aa34609b.jpg";